/* eslint-disable prettier/prettier */
/* eslint-disable react/prop-types */

import { useEffect, useState } from "react";
import { styled } from "@mui/material/styles";
import Button from "@mui/material/Button";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import MDTypography from "components/MDTypography";
import toast from "react-hot-toast";

const VisuallyHiddenInput = styled("input")({
  clip: "rect(0 0 0 0)",
  clipPath: "inset(50%)",
  height: 1,
  overflow: "hidden",
  position: "absolute",
  bottom: 0,
  left: 0,
  whiteSpace: "nowrap",
  width: 1,
});

function InputFileUpload({ onchangeFile, valueF }) {
  const [file, setfile] = useState(valueF ? valueF.name : "");
  const [valueFile, setvalueFile] = useState(valueF ? valueF : null);

  useEffect(() => {
    if (valueF) {
      setfile(valueF.name);
      setvalueFile(valueF);
    } else {
      setfile("");
      setvalueFile(null);
    }
  }, [valueF]);

  const handleFileChange = (e) => {
    const file = e.target.files[0];

    if (file) {
      const maxSizeInBytes = 32 * 1024 * 1024; // 5MB

      if (file.size > maxSizeInBytes) {
        toast.error("El archivo no debe superar los 32MB.");
        e.target.value = ""; // Reset input file
        return;
      }

      setfile(file.name);
      setvalueFile(file);
      onchangeFile(file);
    } else {
      setfile("");
      setvalueFile(null);
      onchangeFile(null);
    }
  };

  return (
    <>
      <Button
        component="label"
        role={undefined}
        variant="contained"
        tabIndex={-1}
        startIcon={<CloudUploadIcon />}
        sx={{ textTransform: "none" }}
      >
        Elegir archivo
        <VisuallyHiddenInput key={file} type="file" onChange={handleFileChange} />
      </Button>
      <MDTypography
        variant="text"
        color="white"
        style={{ opacity: 0.7, fontSize: 12, marginLeft: "16px" }}
      >
        {file}
      </MDTypography>
    </>
  );
}

export default InputFileUpload;
